import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Svg } from "../../../Svg";
export var NodeWithSvg = function(param) {
    var children = param.children, color = param.color, svg = param.svg, _svgPosition = param.svgPosition, svgPosition = _svgPosition === void 0 ? "left" : _svgPosition, height = param.height;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            svg && svgPosition === "left" && /*#__PURE__*/ _jsx(Svg, {
                name: svg,
                color: color,
                height: height
            }),
            children,
            svg && svgPosition === "right" && /*#__PURE__*/ _jsx(Svg, {
                name: svg,
                color: color,
                height: height
            })
        ]
    });
};
